import { render, staticRenderFns } from "./MyFormPanelTester.vue?vue&type=template&id=757e20b2&scoped=true&"
import script from "./MyFormPanelTester.vue?vue&type=script&lang=js&"
export * from "./MyFormPanelTester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757e20b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('757e20b2')) {
      api.createRecord('757e20b2', component.options)
    } else {
      api.reload('757e20b2', component.options)
    }
    module.hot.accept("./MyFormPanelTester.vue?vue&type=template&id=757e20b2&scoped=true&", function () {
      api.rerender('757e20b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyFormPanel/MyFormPanelTester.vue"
export default component.exports